import NotImplemented from '../../common/pages/NotImplemented'

const ActivityLog = () => {
    return (
        <NotImplemented
            header={{ header: 'Activity Log' }}
            label={
                <>
                    <span className="text-primary">Activity Log</span> has not
                    been implemented yet!
                </>
            }
            description={
                <p>Under review and will be implemented at some point 🤓</p>
            }
        />
    )
}

export default ActivityLog
